export const paymentConstant = {
    CHECKOUT: 'PAYMENT_CHECKOUT',
    GET_CHARGE_SUCCESS: 'PAYMENT_GET_CHARGE_SUCCESS',
    CHARGE_SUCCESS: 'PAYMENT_CHARGE_SUCCESS',
    IS_FREE: true
};
